<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import ChevronIcon from "@/components/icons/ChevronIcon.vue";

defineProps<{
  items: [];
  defaultValue?: string | number;
}>();

const emit = defineEmits(["selectOption"]);
</script>

<template>
  <div class="relative inline-block">
    <select
      :value="defaultValue ?? ''"
      class="border rounded-[100px] text-sm text-brown px-4 py-[12px] appearance-none w-full select-none"
      @change="emit('selectOption', $event.target.value)"
    >
      <option
        v-for="(item, index) in items"
        :key="index"
        :value="item"
        class="text-sm text-brown"
      >
        <slot name="option" :item="item">
          {{ item }}
        </slot>
      </option>
    </select>
    <span class="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
      <ChevronIcon />
    </span>
  </div>
</template>
